export const createServiceSlug = (serviceName: string) => {
	const nameToLowercase = serviceName.toLowerCase()
	const serviceSlug = nameToLowercase.replace(/ +/g, '-')
	return serviceSlug
}
